import { useMemo } from "react";
import "./sidebar-icon.css"

export enum SidebarIconsSrc {
  HIGNOME = "/assets/images/hignome-nav-icon.svg",
  MENTORSHIP = "/assets/images/mentorship-nav-icon.svg",
  GRIT = "/assets/images/grit-nav-icon.svg",
  SETTINGS = "/assets/images/settings-nav-icon.svg",
}

interface SidebarIconProps {
  icon: SidebarIconsSrc;
  isSelected?: boolean;
}

const SidebarIcon = (props: SidebarIconProps) => {
  const { icon, isSelected } = props;



  return (
    <div className="sidebar-icon-container">
      <img 
        src={process.env.PUBLIC_URL + icon} 
        alt="" 
        className="sidebar-icon"
      />
    </div>
  );
};

export default SidebarIcon;